import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import Modal from "react-modal";
import "./stage1.css";

import oops from "./images/oopps.gif";
import dust from "./images/dust.png";
import foot from "./images/foot.png";
import hand from "./images/hand.png";
import ink from "./images/ink.png";
import note from "./images/note.png";
import paper from "./images/paper.png";
import cross from "./images/cross.png";

import GameSVG from "./GameSVG";
import { fetchReport } from "../../scoreservice";

Modal.setAppElement("#root");
const STAGE = 1;

export default function Stage1({ updateHeader }) {
       useEffect(() => {
         updateHeader({ backButtonRedirect: "/stage1" });
     
        
       }, []); // run once on mount

  const navigate = useNavigate();

  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [SESSION_KEY, setSessionKey] = useState(null);

  const [userData, setUserData] = useState({});

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  const gameImages = { dust, foot, hand, ink, note, paper, cross };
  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  useEffect(() => {
    const checkStageCompletion = async () => {
      console.log("check stage completion!", userData);

      console.log("test---1", {
        userId: userData.userId,
        sessionId: userData.sessionId,
        organizationId: userData.organizationId,
        stage: STAGE,

      });
      try {
        const res = await fetchReport({
          userId: userData.userId,
          sessionId: userData.sessionId,
          organizationId: userData.organizationId,
          stage: STAGE,

        });



        if (userData?.sessionId && userData?.userId) {
          const key = `stage_timer_${userData.sessionId}_${userData.userId}`;
          setSessionKey(key);

          if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(
              key,
              JSON.stringify({
                userId: userData.userId,
                sessionId: userData.sessionId,
                startTime: Date.now(),
              })
            );
          }
        }



        console.log("userData check", userData);
        if (Number(res?.points) !== 0) {
          console.log("redirecting from here");
          navigate("/stage2", { replace: true });
        }


      } catch (err) {
        console.error("Stage check failed", err);
      }
    };

    if (userData?.sessionId) {
      checkStageCompletion();
    }
  }, [userData]);





  useEffect(() => {
    const sessionData = sessionStorage.getItem(SESSION_KEY);

    if (!sessionData) return;

    const { startTime } = JSON.parse(sessionData);

    const interval = setInterval(() => {
      const elapsedMs = Date.now() - startTime;
      const totalSeconds = Math.floor(elapsedMs / 1000);

      const mins = Math.floor(totalSeconds / 60);
      const secs = totalSeconds % 60;

      setMinutes(mins);
      setSeconds(secs);
    }, 1000);

    return () => clearInterval(interval);
  }, [SESSION_KEY]);

  const showWrongPopup = () => {
    Swal.fire({
      imageUrl: oops,
      showConfirmButton: false,
      background: "transparent",
      backdrop: false,
      timer: 3000,
      allowOutsideClick: false,
      showClass: { popup: "" },
      hideClass: { popup: "" },
      didOpen: popup => {
        popup.style.boxShadow = "none";
        popup.style.border = "none";
      }
    });
  };

  return (
    <div className="stage1_wrapper">
      <div className="row header-1">
        <div className="timer-back-1">
          Time: {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </div>

        <div className="title-wrap-1">
          <h4 className="gameHead-1">
            Crime Scene Analysis: Your team visits the heist-related scene,
            searching for clues.
          </h4>

          <p className="gameSubHead-1">
            Click on the items you think will help solve the case.
          </p>
        </div>




        <div className="score-1">Points: 0</div>
      </div>

      <div className="main1">
        <div className="child-1" id="dust" onClick={() => setIsModalOpen(true)}>
          {/* <img src={gameImages.dust} alt="dust" /> */}
        </div>

        {["foot", "hand", "ink", "note", "paper"].map(id => (
          <div key={id} className="child-1" id={id} onClick={showWrongPopup}>
            {/* <img src={gameImages[id]} alt={id} /> */}
          </div>
        ))}
      </div>

      {/* MODAL */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <img
          src={gameImages.cross}
          className="close-btn"
          onClick={() => setIsModalOpen(false)}
          alt="close"
        />

        <GameSVG time={formattedTime} />
      </Modal>
    </div>
  );
}
